import React, {useState, useContext, useEffect, useRef} from "react";
import {useForm} from "react-hook-form";
import Select from "react-select";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  Backdrop,
  Typography,
  RadioGroup,
  ListItem,
  FormControlLabel,
  Radio,
  Checkbox,
  ButtonGroup,
  Box
} from "@material-ui/core";
import {
  apollo_useStyles,
  Option,
  OptionBool,
  options_bidding,
  options_state,
  options_state_edit,
  options_target,
  options_zeus_billing_type,
  options_zeus_pmp_type,
  options_zeus_fq_class,
  options_zeus_fq_term,
  options_zeus_budget_allocation,
  options_zeus_campaign_type,
  valueToOptionNull,
  ZEUS_BILLING_TYPE,
  ZEUS_DELIVERY_TYPE,
  ZEUS_PMP_TYPE,
  ZEUS_DOMAIN_SETTING,
  ZEUS_FQ_CLASS,
  ZEUS_FQ_TERM,
  ZEUS_FQ_TYPE,
  options_zeus_fq_type,
  CAMPAIGN_GOAL_NUMBER
} from "../../../atom/Apollo_styles";
import {ApolloContext} from "../../../atom/Apollo_Context";
import {ApolloMessage} from "../../../atom/Apollo_Mesasge";
import {ApolloAxios, getResultType} from "../../../atom/Apollo_ApiRequest3";
import {
  hera_account_path,
  hera_audiences_path,
  hera_setpoints_path, zeus_ad_account,
} from "../../../atom/Apollo_links";
import {
  APOLLO_GROUP_OPERATOR,
  APOLLO_SYSTEM_ADMIN, ApolloUserProfileAuth, getEditPermission,
} from "../../../atom/Apollo_Authorization";
import {Bars} from "react-loader-spinner";
import {
  ApolloBasicDistributionDate,
  ApolloBasicLabel,
  ApolloBasicSelect,
  ApolloBasicTextField,
  ApolloBasicCheck
} from "../../../molecule/Apollo_BaseItem";
import {CampaignZeus} from "./CampaignModelZeus";
import moment from "moment";
import {
  ApolloCampaignSchedule,
} from "../../../atom/CAMPAIGN/Apollo_Schedule";
import {useParams} from "react-router-dom";
import {checkDomainStrArrowUnderbar, checkInvalidCharForName} from "../../../common/Apollo_CommonUtil";
import {MenuPlacement} from "react-select/src/types";
import {Audience, SetPoint} from "../CampaignModel";

type ZeusCampaignFormProps = {
  campaignId: number,
  campaignState: {
    campaign: CampaignZeus,
    setCampaign: any,
  },
  scheduleState: {
    schedule: boolean[][],
    setSchedule: any,
  },
  endDateState: {
    endDate: string,
    setEndDate: any,
    endDateInputType: number,
    setEndDateInputType: any,
  },
  submitAction: any,
  goBackAction: any,
  showExtAdCampaignBudgetProportion: boolean,
  setShowExtAdCampaignBudgetProportion: any,
  beforeStartDate: string,
}

type OptionCampaignGoal = {
  value: number,
  label: string,
  deliveryType: number,
  autoBidding: number,
}

type ErrorMessages = {
  excludingAudiences: string,
  trackingPoints: string,
}

type SelectableCampaignPurpose = {
  DeliveryType: number,
  SelectableList: SelectableCampaignPurposeList[],
}

type SelectableCampaignPurposeList = {
  campaignGoal: number,
  autoBidding: number,
}

const RESERVE_BUDGET_MAX = 999999999999;

const valueToOptionCampaignGaol = function (value: any, options: OptionCampaignGoal[]): { value: any, label: string, autoBidding: number } | null {
  let option = options.find(option => option.value === value);
  if (!option) {
    return null;
  } else {
    return option;
  }
}

const isValid = function (campaign: CampaignZeus, errorMessages: ErrorMessages): boolean {
  if (campaign.name === "") return false;
  if (campaign.budgetLimitDaily < 100) return false;
  if (campaign.extAdCampaignBudgetProportion < 0 
    || (0 < campaign.extAdCampaignBudgetProportion && campaign.extAdCampaignBudgetProportion < 10 ) 
    || 101 < campaign.extAdCampaignBudgetProportion) return false;
  if (!campaign.cpa || campaign.cpa < 1) return false;
  if (errorMessages.excludingAudiences !== "" || errorMessages.trackingPoints !== "") return false;
  return true;
}

// 画面名：キャンペーン作成（Zeus）
const CampaignFormZeus = ({
                            campaignId,
                            campaignState,
                            scheduleState,
                            endDateState,
                            submitAction,
                            goBackAction,
                            showExtAdCampaignBudgetProportion,
                            setShowExtAdCampaignBudgetProportion,
                            beforeStartDate
                          }: ZeusCampaignFormProps) => {
  const classes = apollo_useStyles();
  const {state} = useContext(ApolloContext);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const {control, errors, formState, handleSubmit, register, watch} = useForm({mode: "onBlur", reValidateMode: "onBlur"});
  const watchFields = watch(["excludingAudiences", "trackingPoints"]);
  const trackerId = state.current.trackerId;
  const isEditor = getEditPermission(state);
  const [progress, setProgress] = useState(true);
  const [optionAudiences, setOptionAudiences] = useState<Option[]>([]);
  const [audiences, setAudiences] = useState<Option[]>([]);
  const [deletedAudiences, setDeletedAudiences] = useState<Option[]>([]);
  const [optionSetPoints, setOptionSetPoints] = useState<Option[]>([]);
  const [setPoints, setSetPoints] = useState<Option[]>([]);
  const [deletedSetPoints, setDeletedSetPoints] = useState<Option[]>([]);
  const [optionCampaignGoals, setOptionCampaignGoals] = useState<OptionCampaignGoal[]>([]);
  const [optionAutoBiddings, setOptionAutoBiddings] = useState<OptionBool[]>([]);
  const processing = useRef(false);
  const {platformaccountid} = useParams<{platformaccountid: string}>();
  const [errorMessages, setErrorMessages] = useState<ErrorMessages>(
    {
      excludingAudiences: "",
      trackingPoints: "",
    }
  );
  const [isDisabled, setIsDisabled] = useState(false);

  // 配信先ドメイン設定の値を一時的に保存しておくための変数
  const [domainSettingTmp, setDomainSettingTmp] = useState<number>(ZEUS_DOMAIN_SETTING.DOMAIN_EXCLUSION);

  useEffect(() => {
    if (campaignState.campaign.id === 0)  {
      if(audiences.length > 0) setOptionAudiences(audiences);
      return;
    }
    const deletedList: Option[] = [];

    campaignState.campaign.excludingAudiences?.map((id: number) => {
      const option = valueToOptionNull(id, deletedAudiences);
      if (option) deletedList.push(option);
    });

    const mixList = audiences.concat(deletedList);
    setOptionAudiences(mixList);

  }, [audiences, deletedAudiences, campaignState.campaign.id]);

  useEffect(() => {
    if (campaignState.campaign.id === 0) {
      if(setPoints.length > 0) setOptionSetPoints(setPoints);
      return;
    }
    const deletedList: Option[] = [];

    campaignState.campaign.trackingPoints?.map((id: number) => {
      const option = valueToOptionNull(id, deletedSetPoints);
      if (option) deletedList.push(option);
    });

    const mixList = setPoints.concat(deletedList)
    setOptionSetPoints(mixList);

  }, [setPoints, deletedSetPoints, campaignState.campaign.id]);

  useEffect(() => {
    setIsDisabled(campaignId !== 0 && moment(beforeStartDate).isBefore(moment().add(1, 'day').startOf('day')))
  })

  useEffect(() => {
    const messages = {
      excludingAudiences:
        watchFields?.excludingAudiences?.length > 3 ?
          "オーディエンス除外設定は最大3つまで指定可能です。" : "",
      trackingPoints:
        watchFields?.trackingPoints?.length > 5 ?
          "測定ポイント設定は最大5つまで指定可能です。" : "",
    };
    if(messages.excludingAudiences !== errorMessages.excludingAudiences ||
      messages.trackingPoints !== errorMessages.trackingPoints) {
      setErrorMessages(messages);
    }
  }, [watch]);

  useEffect(() => {
    const newOptionBiddings: OptionBool[] = []
    if (campaignId === 0) {
      if(campaignState.campaign.deliveryType === ZEUS_DELIVERY_TYPE.PERFORMANCE &&
        campaignState.campaign.campaignGoal === CAMPAIGN_GOAL_NUMBER.CPA) {
        newOptionBiddings.push(options_bidding[1])
      } else if (campaignState.campaign.deliveryType === ZEUS_DELIVERY_TYPE.PERFORMANCE && (
        campaignState.campaign.campaignGoal === CAMPAIGN_GOAL_NUMBER.TARGET || 
        campaignState.campaign.campaignGoal === CAMPAIGN_GOAL_NUMBER.CLICK ||
        campaignState.campaign.campaignGoal === CAMPAIGN_GOAL_NUMBER.CV )) {
        newOptionBiddings.push(options_bidding[0])
      } else if (campaignState.campaign.deliveryType === ZEUS_DELIVERY_TYPE.DSP &&
        campaignState.campaign.pmpType === ZEUS_PMP_TYPE.OPEN_AUCTION) {
        newOptionBiddings.push(options_bidding[1])
      } else if (campaignState.campaign.deliveryType === ZEUS_DELIVERY_TYPE.DSP &&
        campaignState.campaign.pmpType === ZEUS_PMP_TYPE.PLACEMENT_DESIGNATION) {
        newOptionBiddings.push(options_bidding[1])
      } else if (campaignState.campaign.deliveryType === ZEUS_DELIVERY_TYPE.DSP &&
        campaignState.campaign.pmpType === ZEUS_PMP_TYPE.PREMIUM_PLACEMENT_DESIGNATION) {
        newOptionBiddings.push(options_bidding[0])
      }
    } else {
      options_bidding.map(elem => {
        newOptionBiddings.push(elem);
      })
    }
    setOptionAutoBiddings(newOptionBiddings)

    if (campaignId === 0) {
      let autoBidding = campaignState.campaign.autoBidding;
      if (newOptionBiddings.length > 0) autoBidding = newOptionBiddings[0].value
      campaignState.setCampaign({
        ...campaignState.campaign,
        autoBidding: autoBidding,
      });
    }
  }, [campaignState.campaign.deliveryType, optionCampaignGoals, campaignState.campaign.campaignGoal, campaignState.campaign.pmpType]);

  useEffect(() => {
    if (campaignId === 0 && campaignState.campaign.deliveryType === ZEUS_DELIVERY_TYPE.PERFORMANCE) {
      const options = optionCampaignGoals.filter(x => x.deliveryType === campaignState.campaign.deliveryType)
      campaignState.setCampaign({
        ...campaignState.campaign,
        campaignGoal: options.length > 0 ? options[0].value : -1,
      })
    }
  }, [campaignState.campaign.deliveryType, optionCampaignGoals]);

  useEffect(() => {

    const fetchAccount = async () => {
      const pAccountId = campaignId === 0? platformaccountid: campaignState.campaign.adAccountId;
      const url = `${zeus_ad_account}${pAccountId}`;
      await ApolloAxios.get(url).then(response => {
        if (response.status !== 200) {
          return Promise.reject({
            open: true,
            type: getResultType(response.status === 400 ? -1 : -9),
            errmsg: "アカウント情報を取得できませんでした",
          });
        }
        const newOptionCampaignGoals: OptionCampaignGoal[] = [];
        const purposeList: SelectableCampaignPurpose[] = response.data?.SelectableCampaignPurposeList;
        purposeList?.map((purpose: SelectableCampaignPurpose) => {
          purpose.SelectableList.map((elem) => {
            const option = valueToOptionNull(elem.campaignGoal, options_target);
            if (option) {
              newOptionCampaignGoals.push({
                value: option.value,
                label: option.label,
                deliveryType: purpose.DeliveryType,
                autoBidding: elem.autoBidding,
              })
            }
          })
        });
        setOptionCampaignGoals(newOptionCampaignGoals);

      }).catch(err => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: getResultType(err.type),
            message: err.errmsg,
          }
        });
      });
    }

    // Hera情報等取得
    const fetchAudiences = async () => {
      // トラッカーIDが無い場合
      if (!trackerId) {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: "トラッカーIDがありません"
          }
        });
        return;
      }

      const url = `${process.env.REACT_APP_API_ENDPOINT}${hera_audiences_path}/${trackerId}`;
      await ApolloAxios.get(url).then(response => {
        if (response.status !== 200) {
          return Promise.reject({
            open: true,
            type: getResultType(response.status === 400 ? -1 : -9),
            errmsg: "オーディエンス情報を取得できませんでした",
          });
        }


        const newAudiences: Option[] = [];
        const result: Audience[] = response?.data?.result ?? []
        result.map(data => {
          const option: Option = {
            value: data.ID,
            label: data.isActive ? `${data.ID}_${data.name}` : `${data.ID}_${data.name}（停止中）`,
          }
          newAudiences.push(option);
        });
        setAudiences(newAudiences);

      }).catch(err => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: getResultType(err.type),
            message: err.errmsg,
          }
        });
      });
    }

    const fetchSetPoints = async () => {
      // トラッカーIDが無い場合
      if (!trackerId) return;
      const url = `${process.env.REACT_APP_API_ENDPOINT}${hera_setpoints_path}/${trackerId}`;
      await ApolloAxios.get(url).then(response => {
        if (response.status !== 200) {
          return Promise.reject({
            open: true,
            type: getResultType(response.status === 400 ? -1 : -9),
            errmsg: "測定ポイント情報を取得できませんでした",
          });
        }

        const newSetPoints: Option[] = [];
        const result: SetPoint[] = response?.data?.result ?? []
        result.map(data => {
          const option: Option = {
            value: data.ID,
            label: data.isActive ? `${data.ID}_${data.name}` : `${data.ID}_${data.name}（停止中）`,
          }
          newSetPoints.push(option);
        });
        setSetPoints(newSetPoints);

      }).catch(err => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: getResultType(err.type),
            message: err.errmsg,
          }
        });
      });
    }

    const fetchDeletedAudiences = async () => {
      // トラッカーIDが無い or 新規作成の場合
      if (!trackerId || campaignId === 0) return;
      const url = `${process.env.REACT_APP_API_ENDPOINT}${hera_account_path}/${state.current.accountId}/audiences/deleted`;
      await ApolloAxios.get(url).then(response => {
        if (response.status !== 200) {
          return Promise.reject({
            open: true,
            type: getResultType(response.status === 400 ? -1 : -9),
            errmsg: "オーディエンス情報を取得できませんでした",
          });
        }

        const newDeletedAudiences: Option[] = [];
        response.data?.result?.map(function (data: { ID: number, name: string }) {
          const option: Option = {
            value: data.ID,
            label: `${data.ID}_${data.name}（削除済み）`,
          }
          newDeletedAudiences.push(option);
        });
        setDeletedAudiences(newDeletedAudiences);
      }).catch(err => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: getResultType(err.type),
            message: err.errmsg,
          }
        });
      });
    }

    const fetchDeletedSetPoints = async () => {
      // トラッカーIDが無い or 新規作成の場合
      if (!trackerId || campaignId === 0) return;
      const url = `${process.env.REACT_APP_API_ENDPOINT}${hera_account_path}/${state.current.accountId}/setpoints/deleted`;
      await ApolloAxios.get(url).then(response => {
        if (response.status !== 200) {
          return Promise.reject({
            open: true,
            type: getResultType(response.status === 400 ? -1 : -9),
            errmsg: "測定ポイント情報を取得できませんでした",
          });
        }

        const newDeletedSetPoints: Option[] = [];
        response.data?.result?.map(function (data: { ID: number, name: string }) {
          const option: Option = {
            value: data.ID,
            label: `${data.ID}_${data.name}（削除済み）`,
          }
          newDeletedSetPoints.push(option);
        });
        setDeletedSetPoints(newDeletedSetPoints);
      }).catch(err => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: getResultType(err.type),
            message: err.errmsg,
          }
        });
      });
    }

    const fetchAll = async () => {
      processing.current = true;
      setmsg({
        type: "loading",
        payload: {
          ...data,
          loading: true
        }
      });

      await Promise.all(
        [fetchAccount(), fetchSetPoints(), fetchAudiences(), fetchDeletedAudiences(), fetchDeletedSetPoints()]
      ).finally(() => {
        processing.current = false;
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false
          }
        })
        setProgress(false)
      });
    }
    fetchAll();

  }, []);

  const filterOptionCampaignGoals = (optionCampaignGoals: OptionCampaignGoal[]): OptionCampaignGoal[] => {
    const optionCampaignGoalsNew :OptionCampaignGoal[] = [];

    /** Performance Network の選択肢追加 */
    if(campaignState.campaign.deliveryType === ZEUS_DELIVERY_TYPE.PERFORMANCE) {
      optionCampaignGoals.forEach(campaignGoals => {
        if(campaignGoals.deliveryType === ZEUS_DELIVERY_TYPE.PERFORMANCE) {
          optionCampaignGoalsNew.push(campaignGoals);
        }
      })
    }

    /** docomo connecting path DSP の選択肢追加 */
    if(campaignState.campaign.deliveryType === ZEUS_DELIVERY_TYPE.DSP) {
      if(campaignState.campaign.pmpType === ZEUS_PMP_TYPE.OPEN_AUCTION ||
        campaignState.campaign.pmpType === ZEUS_PMP_TYPE.PLACEMENT_DESIGNATION) {
        const tmpOptionCampaignGoal :OptionCampaignGoal = {
          value: options_target[2].value,
          label: options_target[2].label,
          deliveryType: ZEUS_DELIVERY_TYPE.DSP,
          // yamlファイルに記載されていた2を固定で代入
          autoBidding: 2,
        }
        optionCampaignGoalsNew.push(tmpOptionCampaignGoal);
      } else if (campaignState.campaign.pmpType === ZEUS_PMP_TYPE.PREMIUM_PLACEMENT_DESIGNATION) {
        const tmpOptionCampaignGoal :OptionCampaignGoal = {
          value: options_target[0].value,
          label: options_target[0].label,
          deliveryType: ZEUS_DELIVERY_TYPE.DSP,
          // yamlファイルに記載されていた2を固定で代入
          autoBidding: 2,
        }
        optionCampaignGoalsNew.push(tmpOptionCampaignGoal);
      }
    }
    return optionCampaignGoalsNew;
  };

  const menuPlacement: MenuPlacement =  campaignId === 0? "auto": "top";
  const inputProps = {
    id: {
      id: "id",
      label: "キャンペーンID",
    },
    deliveryType: {
      id: "deliveryType",
      label: "キャンペーン種別",
      readOnly: !isEditor || campaignId !== 0,
      disabled: !isEditor || campaignId !== 0,
      options: options_zeus_campaign_type,
    },
    billingType: {
      id: "billingType",
      label: "課金種別",
      readOnly: true,
      disabled: true,
      options: options_zeus_billing_type,
    },
    pmpType: {
      id: "pmpType",
      label: "取引形式",
      readOnly: !isEditor || campaignId !== 0,
      disabled: !isEditor || campaignId !== 0,
      options: options_zeus_pmp_type,
    },
    name: {
      id: "name",
      label: "キャンペーン名",
      type: "text",
      inputProps: {
        readOnly: !isEditor,
      },
      rules: {
        required: "必須入力項目です。",
        min: {
          value: 1,
          message: "1文字以上を入力して下さい。"
        },
        max: {
          value: 255,
          message: "255文字以内で入力して下さい。"
        },
        validate: (e: string) => {
          const errorMessage = checkInvalidCharForName(e);
          if (errorMessage) {
            return errorMessage;
          }
        },
      },
      required: true,
    },
    status: {
      id: "status",
      label: "ステータス",
      readOnly: !isEditor,
      options: campaignId !== 0 ? options_state_edit : options_state,
    },
    budgetLimitDaily: {
      id: "budgetLimitDaily",
      label: "日予算額",
      type: "text",
      inputProps: {
        readOnly: !isEditor,
      },
      rules: {
        // NOTE: 「type: "text"」の為、validateの中に処理を記載
        validate: (e: string) => {
          const regExp = new RegExp('^[1-9][0-9]*$');
          if(e === "") {
            return "必須入力項目です。";
          } else if(Number(e) < 100) {
            return "100以上を入力して下さい。";
          } else if(!regExp.test(e)) {
            return "半角数字(先頭は0以外)を入力してください。";
          } else if(Number(e) > RESERVE_BUDGET_MAX) {
            return `${RESERVE_BUDGET_MAX}以下を入力して下さい。`;
          }
        },
      },
      unNegative: true,
      required: true,
    },
    showExtAdCampaignBudgetProportion: {
      id: "showExtAdCampaignBudgetProportion",
      label: "ドコモ媒体以外の一般メディアへの配信(推奨)",
    },
    extAdCampaignBudgetProportion: {
      id: "extAdCampaignBudgetProportion",
      label: "一般メディアに充当する日予算割合(%)",
      type: "number",
      inputProps: {
        readOnly: !isEditor,
      },
      rules: {
        required: "必須入力項目です。",
        min: {
          value: 10,
          message: "10以上を入力して下さい。"
        },
        pattern: {
          value: /^[1-9][0-9]*$/i,
          message: "半角数字(先頭は0以外)を入力してください。"
        },
        max: {
          value: 100,
          message: `100以下を入力して下さい。`,
        },
      },
      unNegative: true,
      // required: true,
    },
    schedule: {
      weekLyType: 1,
    },
    startDate: {
      id: "startDate",
      label: "開始",
      disabled: (!isEditor),
      min: moment().add(1, 'day').startOf('day').format("YYYY-MM-DDTHH:mm"),
      inputRef: "",
    },
    endDate: {
      id: "endDate",
      label: "終了",
      inputType: endDateState.endDateInputType,
      setInputType: endDateState.setEndDateInputType,
      min: moment().add(1, 'day').startOf('day').format("YYYY-MM-DDTHH:mm"),
      disabled: (!isEditor || endDateState.endDateInputType === 1),
      style: endDateState.endDateInputType === 1 ? {color: `rgba(0, 0, 0, 0.38)`} : {},
      inputRef: "",
    },
    campaignGoal: {
      id: "campaignGoal",
      label: "キャンペーンの目的",
      options: filterOptionCampaignGoals(optionCampaignGoals),
      readOnly: !isEditor || campaignId !== 0 || campaignState.campaign.deliveryType !== ZEUS_DELIVERY_TYPE.PERFORMANCE,
      disabled: !isEditor || campaignId !== 0 || campaignState.campaign.deliveryType !== ZEUS_DELIVERY_TYPE.PERFORMANCE,
    },
    cpa: {
      id: "cpa",
      label: "目標獲得単価",
      type: "text",
      inputProps: {
        readOnly: !isEditor,
      },
      rules: {
        // NOTE: 「type: "text"」の為、validateの中に処理を記載
        validate: (e: string) => {
          const regExp = new RegExp('^[1-9][0-9]*$');
          if(e === "") {
            return "必須入力項目です。";
          } else if(Number(e) < 1) {
            return "1以上を入力して下さい。";
          } else if(!regExp.test(e)) {
            return "半角数字(先頭は0以外)を入力してください。";
          } else if(Number(e) > RESERVE_BUDGET_MAX) {
            return `${RESERVE_BUDGET_MAX}以下を入力して下さい。`;
          }
        },
      },
      unNegative: true,
      required: true,
    },
    autoBidding: {
      id: "autoBidding",
      label: "入札戦略",
      options: optionAutoBiddings,
      readOnly: !isEditor || campaignId !== 0 || campaignState.campaign.deliveryType !== ZEUS_DELIVERY_TYPE.PERFORMANCE,
      disabled: !isEditor || campaignId !== 0 || campaignState.campaign.deliveryType !== ZEUS_DELIVERY_TYPE.PERFORMANCE,
    },
    fqExist: {
      id: "fqExist",
      ariaLabel: "fqExist",
      name: "フリークエンシーキャップ設定有無",
      readOnly: false,
      disabled: false,
    },
    fqClass: {
      id: "fqClass",
      ariaLabel: "fqClass",
      label: "フリークエンシーキャップ階層",
      name: "フリークエンシーキャップ階層",
      options: options_zeus_fq_class,
      readOnly: !campaignState.campaign.fqExist,
      disabled: !campaignState.campaign.fqExist,
    },
    fqTerm: {
      id: "fqTerm",
      ariaLabel: "fqTerm",
      label: "フリークエンシーキャップ期間",
      name: "フリークエンシーキャップ期間",
      options: options_zeus_fq_term,
      readOnly: !campaignState.campaign.fqExist,
      disabled: !campaignState.campaign.fqExist,
    },
    fqType: {
      id: "fqType",
      ariaLabel: "fqType",
      label: "",
      options: options_zeus_fq_type,
      readOnly: true,
      disabled: true,
    },
    fqCount: {
      id: "fqCount",
      ariaLabel: "fqCount",
      label: "フリークエンシーキャップ回数",
      readOnly: !campaignState.campaign.fqExist,
      disabled: !campaignState.campaign.fqExist,
      type: "number",
      rules: {
        required: "必須入力項目です。",
        min: {
          value: 1,
          message: "1以上、255以下の整数を入力してください。"
        },
        pattern: {
          value: /^[1-9][0-9]*$/i,
          message: "半角数字(先頭は0以外)を入力してください。"
        },
        max: {
          value: 255,
          message: `1以上、255以下の整数を入力してください。`,
        },
      },
      required: true,
      unNegative: true,
    },
    budgetAllocation: {
      id: "budgetAllocation",
      ariaLabel: "budgetAllocation",
      label: "予算配分",
      options: options_zeus_budget_allocation,
      readOnly: false,
      disabled: false,
    },
    excludingAudiences: {
      id: "excludingAudiences",
      label: "オーディエンス除外設定",
      isMulti: true,
      rules: {},
      options: optionAudiences,
      readOnly: !isEditor,
      menuPlacement: menuPlacement,
    },
    domainSetting: {
      id: "domainSetting",
      ariaLabel: "domainSetting",
      name: "配信先ドメイン除外/指定選択",
      readOnly: false,
      disabled: false,
    },
    adCampaignExcludingDomains: {
      id: "adCampaignExcludingDomains",
      label: "配信先ドメイン除外設定",
      multiline: true,
      rows: 10,
      rules: {
        validate: (e: string) => {
          console.log(`adCampaignExcludingDomains: ${e}`);

          const domains: string[] = e.split("\n")

          if (e == "" || domains.every(domain => domain == "")) return `必須入力項目です。`;

          const maximumRows: number = 1000
          if (domains.length > maximumRows) return `${maximumRows}行以内で入力して下さい。`;

          const maxLength: number = 250
          let errorRows1: number[] = [] // 文字数
          let errorRows2: number[] = [] // 禁止文字
          let displayErrMsg1: string = `1ドメインは${maxLength}文字以下で入力して下さい。`
          let displayErrMsg2: string = ``
          domains.forEach((elem, idx) => {
            if (elem.length > maxLength) errorRows1.push(idx+1);
              const errMsg = checkDomainStrArrowUnderbar(elem);
              if (errMsg) {
                errorRows2.push(idx+1);
                displayErrMsg2 = errMsg
              }
          })
          let errorMessages: string[] = []
          if (errorRows1.length > 0) errorMessages.push(`${displayErrMsg1}(${errorRows1.join(", ")}行目)`)
          if (errorRows2.length > 0) errorMessages.push(`${displayErrMsg2}(${errorRows2.join(", ")}行目)`)
          if (errorMessages.length) return errorMessages.join("、")
        }
      },
    },
    adCampaignTargetDomains: {
      id: "adCampaignTargetDomains",
      label: "配信先ドメイン指定設定",
      multiline: true,
      rows: 10,
      rules: {
        validate: (e: string) => {
          console.log(`adCampaignTargetDomains: ${e}`);

          const domains: string[] = e.split("\n")

          if (e == "" || domains.every(domain => domain == "")) return `必須入力項目です。`;

          const maximumRows: number = 1000
          if (domains.length > maximumRows) return `${maximumRows}行以内で入力して下さい。`;

          const maxLength: number = 250
          let errorRows1: number[] = [] // 文字数
          let errorRows2: number[] = [] // 禁止文字
          let displayErrMsg1: string = `1ドメインは${maxLength}文字以下で入力して下さい。`
          let displayErrMsg2: string = ``
          domains.forEach((elem, idx) => {
            if (elem.length > maxLength) errorRows1.push(idx+1);
              const errMsg = checkDomainStrArrowUnderbar(elem);
              if (errMsg) {
                errorRows2.push(idx+1);
                displayErrMsg2 = errMsg
              }
          })
          let errorMessages: string[] = []
          if (errorRows1.length > 0) errorMessages.push(`${displayErrMsg1}(${errorRows1.join(", ")}行目)`)
          if (errorRows2.length > 0) errorMessages.push(`${displayErrMsg2}(${errorRows2.join(", ")}行目)`)
          if (errorMessages.length) return errorMessages.join("、")
        }
      },
    },
    trackingPoints: {
      id: "trackingPoints",
      label: "測定ポイント設定",
      isMulti: true,
      rules: {},
      options: optionSetPoints,
      readOnly: !isEditor,
      menuPlacement: menuPlacement,
    },
  };

  const onSubmit = handleSubmit(async () => {
    if (processing.current) return;
    if (formState.isSubmitting) return;
    processing.current = true;
    await submitAction(
      optionAudiences,
      optionSetPoints,
    );
    processing.current = false;
    setProgress(false);
  });

  return (
    <React.Fragment>
      <Backdrop className={classes.backdrop2} open={progress}>
        <Bars color="#00BFFF" height={80} width={80}/>
      </Backdrop>
      <form onSubmit={onSubmit}>
        <Card className={classes.root} square variant="outlined">
          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <ApolloBasicLabel label={"メニュー"} value={"パフォーマンス広告"}/>
              </Grid>
              <Grid item xs={12}>
                <ApolloBasicTextField
                  id={inputProps.id.id}
                  label={inputProps.id.label}
                  value={campaignId === 0 ? "自動採番" : campaignId}
                  disabled={true}
                  error={errors.id}
                  required={true}
                />
              </Grid>
              <Grid item xs={12}>
                <ApolloBasicSelect
                  id={inputProps.deliveryType.id}
                  label={inputProps.deliveryType.label}
                  options={inputProps.deliveryType.options}
                  value={campaignState.campaign.deliveryType}
                  control={control}
                  readOnly={inputProps.deliveryType.readOnly}
                  disabled={inputProps.deliveryType.disabled}
                  errors={errors.deliveryType}
                  setState={(e: any) => {
                    let billingType = 0;
                    let extAdCampaignBudgetProportion = campaignState.campaign.extAdCampaignBudgetProportion
                    let campaignGoal = campaignState.campaign.campaignGoal
                    let pmpType = campaignState.campaign.pmpType
                    let autoBidding = campaignState.campaign.autoBidding
                    let fqExist = campaignState.campaign.fqExist
                    let fqClass = campaignState.campaign.fqClass
                    let fqTerm = campaignState.campaign.fqTerm
                    let fqCount = campaignState.campaign.fqCount
                    let fqType = campaignState.campaign.fqType
                    let domainSetting = campaignState.campaign.domainSetting
                    let adCampaignExcludingDomains = campaignState.campaign.adCampaignExcludingDomains
                    let adCampaignTargetDomains = campaignState.campaign.adCampaignTargetDomains
                    switch(e) {
                      case ZEUS_DELIVERY_TYPE.PERFORMANCE:
                        billingType = ZEUS_BILLING_TYPE.CPC_CPM
                        campaignGoal = 0
                        autoBidding = false
                        pmpType = ZEUS_PMP_TYPE.OPEN_AUCTION
                        fqExist = false
                        fqClass = ZEUS_FQ_CLASS.CAMPAIGN
                        fqTerm = ZEUS_FQ_TERM.DAYLY
                        fqCount = 1
                        fqType = 1
                        domainSetting = ZEUS_DOMAIN_SETTING.UNSPECIFIED
                        adCampaignExcludingDomains = null
                        adCampaignTargetDomains = null
                        break;
                      case ZEUS_DELIVERY_TYPE.DSP:
                        billingType = ZEUS_BILLING_TYPE.CPM
                        extAdCampaignBudgetProportion = 0
                        switch(pmpType) {
                          case ZEUS_PMP_TYPE.OPEN_AUCTION:
                            campaignGoal = 2;
                            autoBidding = true;
                            break;
                          case ZEUS_PMP_TYPE.PLACEMENT_DESIGNATION:
                            campaignGoal = 2;
                            autoBidding = true;
                            break;
                          case ZEUS_PMP_TYPE.PREMIUM_PLACEMENT_DESIGNATION:
                            campaignGoal = 0;
                            autoBidding = false
                            break;
                        }
                        setShowExtAdCampaignBudgetProportion(false);
                        break;
                    }

                    campaignState.setCampaign({
                      ...campaignState.campaign,
                      billingType: billingType,
                      deliveryType: e,
                      extAdCampaignBudgetProportion: extAdCampaignBudgetProportion,
                      campaignGoal: campaignGoal,
                      autoBidding: autoBidding,
                      pmpType: pmpType,
                      fqExist: fqExist,
                      fqClass: fqClass,
                      fqTerm: fqTerm,
                      fqCount: fqCount,
                      fqType: fqType,
                      domainSetting: domainSetting,
                      adCampaignExcludingDomains: adCampaignExcludingDomains,
                      adCampaignTargetDomains: adCampaignTargetDomains,
                    })
                  }}
                />
              </Grid>
              {campaignState.campaign.deliveryType === ZEUS_DELIVERY_TYPE.DSP &&
                <Grid item xs={12}>
                  <ApolloBasicSelect
                    id={inputProps.pmpType.id}
                    label={inputProps.pmpType.label}
                    options={inputProps.pmpType.options}
                    value={campaignState.campaign.pmpType}
                    control={control}
                    readOnly={inputProps.pmpType.readOnly}
                    disabled={inputProps.pmpType.disabled}
                    errors={errors}
                    setState={(e: any) => {
                      let campaignGoal = campaignState.campaign.campaignGoal;
                      let autoBidding = campaignState.campaign.autoBidding;
                      switch(e) {
                        case ZEUS_PMP_TYPE.OPEN_AUCTION:
                          campaignGoal = 2;
                          autoBidding = true;
                          break;
                        case ZEUS_PMP_TYPE.PLACEMENT_DESIGNATION:
                          campaignGoal = 2;
                          autoBidding = true;
                          break;
                        case ZEUS_PMP_TYPE.PREMIUM_PLACEMENT_DESIGNATION:
                          campaignGoal = 0;
                          autoBidding = false;
                          break;
                      }
                      campaignState.setCampaign({
                        ...campaignState.campaign,
                        pmpType: e,
                        campaignGoal: campaignGoal,
                        autoBidding: autoBidding,
                      })
                    }}
                  />
                </Grid>
              }
              <Grid item xs={12}>
                <ApolloBasicSelect
                  id={inputProps.billingType.id}
                  label={inputProps.billingType.label}
                  options={inputProps.billingType.options}
                  value={campaignState.campaign.billingType}
                  control={control}
                  readOnly={inputProps.billingType.readOnly}
                  disabled={inputProps.billingType.disabled}
                  errors={errors.billingType}
                  setState={(e: any) => {}}
                />
              </Grid>
              <Grid item xs={12}>
                <ApolloBasicTextField
                  id={inputProps.name.id}
                  label={inputProps.name.label}
                  type={inputProps.name.type}
                  value={campaignState.campaign.name}
                  inputProps={inputProps.name.inputProps}
                  inputRef={register(
                    inputProps.name.rules,
                  )}
                  error={errors.name}
                  required={inputProps.name.required}
                  setState={(e: any) => campaignState.setCampaign({
                    ...campaignState.campaign,
                    name: e
                  })}
                />
              </Grid>
              <Grid item xs={12}>
                <ApolloBasicSelect
                  id={inputProps.status.id}
                  label={inputProps.status.label}
                  options={inputProps.status.options}
                  value={campaignState.campaign.status}
                  control={control}
                  readOnly={inputProps.status.readOnly}
                  errors={errors.status}
                  setState={(e: any) => campaignState.setCampaign({
                    ...campaignState.campaign,
                    status: e
                  })}
                />
              </Grid>
              <Grid item xs={12}>
                <ApolloBasicTextField
                  id={inputProps.budgetLimitDaily.id}
                  label={inputProps.budgetLimitDaily.label}
                  type={inputProps.budgetLimitDaily.type}
                  value={campaignState.campaign.budgetLimitDaily || ""}
                  inputProps={inputProps.budgetLimitDaily.inputProps}
                  inputRef={register(
                    inputProps.budgetLimitDaily.rules,
                  )}
                  error={errors.budgetLimitDaily}
                  required={inputProps.budgetLimitDaily.required}
                  setState={(e: any) => campaignState.setCampaign({
                    ...campaignState.campaign,
                    budgetLimitDaily: Number(e),
                  })}
                  unNegative={inputProps.budgetLimitDaily.unNegative}
                />
              </Grid>
              {campaignState.campaign.deliveryType === ZEUS_DELIVERY_TYPE.PERFORMANCE &&
                <ApolloBasicCheck
                  id={inputProps.showExtAdCampaignBudgetProportion.id}
                  label={inputProps.showExtAdCampaignBudgetProportion.label}
                  checked={showExtAdCampaignBudgetProportion}
                  setState={(checked: boolean) => {
                    setShowExtAdCampaignBudgetProportion(checked);
                    campaignState.setCampaign({
                      ...campaignState.campaign,
                      extAdCampaignBudgetProportion: checked ? 10 : 0
                    })
                  }}
                />
              }
              {showExtAdCampaignBudgetProportion && <Grid item xs={12}>
                <ApolloBasicTextField
                  id={inputProps.extAdCampaignBudgetProportion.id}
                  label={inputProps.extAdCampaignBudgetProportion.label}
                  type={inputProps.extAdCampaignBudgetProportion.type}
                  value={campaignState.campaign.extAdCampaignBudgetProportion || ""}
                  inputProps={inputProps.extAdCampaignBudgetProportion.inputProps}
                  inputRef={register(
                    inputProps.extAdCampaignBudgetProportion.rules,
                  )}
                  error={errors.extAdCampaignBudgetProportion}
                  setState={(e: any) => campaignState.setCampaign({
                    ...campaignState.campaign,
                    extAdCampaignBudgetProportion: Number(e),
                  })}
                  unNegative={inputProps.extAdCampaignBudgetProportion.unNegative}
                />
              </Grid>}
              <Grid item xs={12}>
                <ApolloCampaignSchedule
                  schedule={scheduleState.schedule}
                  setSchedule={scheduleState.setSchedule}
                  weekLyType={inputProps.schedule.weekLyType}
                />
              </Grid>
              <Grid item xs={12}>
                <ApolloBasicDistributionDate
                  startDate={{
                    id: inputProps.startDate.id,
                    value: campaignState.campaign.startDate,
                    disabled: inputProps.startDate.disabled || isDisabled,
                    inputProps: {
                      min: inputProps.startDate.min,
                    },
                    inputRef: register({
                      validate: (value: string) => {
                        if (value === "") {
                          return "必須入力項目です。"
                        }
                        const nextDay = moment().add(1, "day").startOf("day");
                        const inputDay = moment(value, "YYYY-MM-DDTHH:mm");
                        const beforeDay = moment(beforeStartDate, "YYYY-MM-DDTHH:mm");
                       
                        if (campaignId === 0) {
                          if (inputDay.diff(nextDay) < 0) {
                            return '翌日以降を指定してください。'
                          }
                        } else {
                          if (!isDisabled && !inputDay.isSame(beforeDay)) {
                            if (inputDay.diff(nextDay) < 0) {
                              return '翌日以降を指定してください。'
                            }
                            if (beforeDay.diff(nextDay) < 0) {
                              setIsDisabled(true)
                              return '既に掲載が開始された、又は本日に掲載が開始されるキャンペーンの掲載開始日時は変更できません。'
                            }
                          }
                      }
                      },
                    }),
                    errors: errors.startDate,
                    setState: (e: any) => campaignState.setCampaign({
                      ...campaignState.campaign,
                      startDate: e,
                    }),
                  }}
                  endDate={{
                    id: inputProps.endDate.id,
                    value: campaignState.campaign.endDate,
                    inputType: inputProps.endDate.inputType,
                    inputTypeDisabled: {
                      radio1: false,
                      radio2: false,
                    },
                    inputProps: {
                      min: inputProps.endDate.min,
                      disabled: inputProps.endDate.disabled,
                      style: inputProps.endDate.style,
                    },
                    inputRef: register({
                      validate: (value: string) => {
                        if (value === "") {
                          return "必須入力項目です。";
                        }
                        const inputDay = moment(value, "YYYY-MM-DDTHH:mm");
                        const startDate = moment(campaignState.campaign.startDate, "YYYY-MM-DDTHH:mm");
                        if (inputProps.endDate.inputType === 2 && !inputDay.isAfter(startDate)) {
                          return "掲載開始日時以降を指定してください。";
                        }
                      },
                    }),
                    errors: errors.endDate,
                    setInputType: endDateState.setEndDateInputType,
                    setState: (e: any) => endDateState.setEndDate(e),
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom component="div">
                  {inputProps.campaignGoal.label}
                </Typography>
                {/** ターゲットリーチが"value:0"のため、ApolloBasicSelectは使えない */}
                <Select
                  id={inputProps.campaignGoal.id}
                  options={inputProps.campaignGoal.options}
                  value={inputProps.campaignGoal.options.find(v => v.value === campaignState.campaign.campaignGoal)}
                  control={control}
                  isDisabled={inputProps.campaignGoal.readOnly}
                  errors={errors.campaignGoal}
                  onChange={(e: any) => {
                    campaignState.setCampaign({
                      ...campaignState.campaign,
                      campaignGoal: Number(e.value),
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <ApolloBasicTextField
                  id={inputProps.cpa.id}
                  label={inputProps.cpa.label}
                  type={inputProps.cpa.type}
                  value={campaignState.campaign.cpa || ""}
                  inputProps={inputProps.cpa.inputProps}
                  inputRef={register(
                    inputProps.cpa.rules,
                  )}
                  error={errors.cpa}
                  required={inputProps.cpa.required}
                  setState={(e: any) => campaignState.setCampaign({
                    ...campaignState.campaign,
                    cpa: Number(e),
                  })}
                  unNegative={inputProps.cpa.unNegative}
                />
              </Grid>
              <Grid item xs={12}>
                <ApolloBasicSelect
                  id={inputProps.autoBidding.id}
                  label={inputProps.autoBidding.label}
                  options={inputProps.autoBidding.options}
                  value={campaignState.campaign.autoBidding}
                  control={control}
                  disabled={inputProps.autoBidding.disabled}
                  errors={errors.autoBidding}
                  setState={(e: any) => campaignState.setCampaign({
                    ...campaignState.campaign,
                    autoBidding: e
                  })}
                />
              </Grid>
              {campaignState.campaign.deliveryType === ZEUS_DELIVERY_TYPE.DSP &&
                <Grid item xs={12}>
                  <Typography variant="subtitle1" component="div">
                    {inputProps.fqExist.name}
                  </Typography>
                  <FormControlLabel 
                    control={
                      <Checkbox 
                        onChange={(_, checked) => {
                          campaignState.setCampaign({
                            ...campaignState.campaign,
                            fqExist: checked,
                          });
                        }}
                        checked={campaignState.campaign.fqExist}
                      />
                    } 
                    label="設定する"                 
                  />
                </Grid>
              }
              {(campaignState.campaign.deliveryType === ZEUS_DELIVERY_TYPE.DSP && campaignState.campaign.fqExist) &&
                <Grid item xs={12}>
                  <Grid
                    container
                    alignItems= "center"
                  >
                    <Grid item>
                      <Box pl={2} sx={{ fontSize: "1rem" }}>
                        階層：
                      </Box>
                    </Grid>
                    <Grid item>
                      <RadioGroup
                        aria-label={inputProps.fqClass.ariaLabel}
                        name={inputProps.fqClass.name}
                        className={classes.radioGroup}
                        value={campaignState.campaign.fqClass}
                        onChange={(e) => {
                          campaignState.setCampaign({
                            ...campaignState.campaign,
                            fqClass: Number(e.target.value),
                          });
                        }}
                      >
                        <ListItem>
                          {inputProps.fqClass.options.map((x) => 
                            <FormControlLabel
                              value={x.value}
                              control={<Radio checked={campaignState.campaign.fqClass === x.value} disabled={inputProps.fqClass.disabled} />}
                              label={x.label}
                            />
                          )}
                        </ListItem>
                      </RadioGroup>
                    </Grid>
                  </Grid>
                </Grid>
              }
              {(campaignState.campaign.deliveryType === ZEUS_DELIVERY_TYPE.DSP && campaignState.campaign.fqExist) &&
                <Grid item xs={12}>
                  <Grid
                    container
                    alignItems= "center"
                  >
                    <Grid item>
                      <Box pl={2} sx={{ fontSize: "1rem" }}>
                        期間：
                      </Box>
                    </Grid>
                    <Grid item>
                      <RadioGroup
                        aria-label={inputProps.fqTerm.ariaLabel}
                        name={inputProps.fqTerm.name}
                        className={classes.radioGroup}
                        value={campaignState.campaign.fqTerm}
                        onChange={(e) => {
                          campaignState.setCampaign({
                            ...campaignState.campaign,
                            fqTerm: Number(e.target.value),
                          });
                        }}
                      >
                        <ListItem>
                          {inputProps.fqTerm.options.map((x) => 
                            <FormControlLabel
                              value={x.value}
                              control={<Radio checked={campaignState.campaign.fqTerm === x.value} disabled={inputProps.fqTerm.disabled} />}
                              label={x.label}
                            />
                          )}
                        </ListItem>
                      </RadioGroup>  
                    </Grid>
                  </Grid>
                </Grid>
              }
              {(campaignState.campaign.deliveryType === ZEUS_DELIVERY_TYPE.DSP && campaignState.campaign.fqExist) &&
                <Grid item xs={12}>
                  <Grid
                    container
                    alignItems= "center"
                  >
                    <Grid item>
                      <Box pl={2} pb={2} sx={{ fontSize: "1rem" }}>
                        項目：
                      </Box>
                    </Grid>
                    <Grid item>
                      <Box pl={2} pb={2} sx={{ width: "170px" }}>
                        <Select
                          // 「vimp」を固定で送信するため、現地点では特に値の入れ替え等は行わない。labelの値を入れたくない為、ApolloBasicTextFieldは未使用
                          value={inputProps.fqType.options.find(v => v.value === ZEUS_FQ_TYPE.VIMP)}
                          options={inputProps.fqType.options}
                          isDisabled={inputProps.fqType.disabled}
                          fullWidth
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              }
              {(campaignState.campaign.deliveryType === ZEUS_DELIVERY_TYPE.DSP && campaignState.campaign.fqExist) &&
                <Grid item xs={12}>
                  <ApolloBasicTextField
                    id={inputProps.fqCount.id}
                    label={inputProps.fqCount.label}
                    value={campaignState.campaign.fqCount || ""}
                    type={inputProps.fqCount.type}
                    disabled={inputProps.fqCount.disabled}
                    error={errors.fqCount}
                    inputRef={register(
                      inputProps.fqCount.rules,
                    )}
                    setState={(e: any) => campaignState.setCampaign({
                      ...campaignState.campaign,
                      fqCount: Number(e),
                    })}
                    unNegative={inputProps.fqCount.unNegative}
                  />
                </Grid>
              }
              {(campaignState.campaign.deliveryType === ZEUS_DELIVERY_TYPE.DSP) &&
                <Grid item xs={12}>
                  <ApolloBasicSelect
                    id={inputProps.budgetAllocation.id}
                    label={inputProps.budgetAllocation.label}
                    options={inputProps.budgetAllocation.options}
                    value={campaignState.campaign.budgetAllocation}
                    control={control}
                    readOnly={inputProps.budgetAllocation.readOnly}
                    disabled={inputProps.budgetAllocation.disabled}
                    errors={errors.budgetAllocation}
                    setState={(e: any) => campaignState.setCampaign({
                      ...campaignState.campaign,
                      budgetAllocation: e
                    })}
                  />
                </Grid>
              }
              <Grid item xs={12}>
                <ApolloBasicSelect
                  id={inputProps.excludingAudiences.id}
                  label={inputProps.excludingAudiences.label}
                  options={inputProps.excludingAudiences.options}
                  value={campaignState.campaign.excludingAudiences}
                  isMulti={inputProps.excludingAudiences.isMulti}
                  control={control}
                  readOnly={inputProps.excludingAudiences.readOnly}
                  errors={errors.excludingAudiences}
                  rules={inputProps.excludingAudiences.rules}
                  menuPlacement={inputProps.excludingAudiences.menuPlacement}
                  setState={(e: any) => {
                    const setVal = e ? e.map((target: Option) => {
                      return target.value;
                    }) : [];
                    campaignState.setCampaign({
                      ...campaignState.campaign,
                      excludingAudiences: setVal,
                    });
                  }}
                />
                {errorMessages.excludingAudiences !== "" &&
                <Typography variant="caption" className={classes.errorMessage}>
                  {errorMessages.excludingAudiences}
                </Typography>
                }
              </Grid>

              {campaignState.campaign.deliveryType === ZEUS_DELIVERY_TYPE.DSP &&
              <>
                <Grid item xs={12}>
                  <Typography variant="subtitle1" component="div">
                    {inputProps.domainSetting.name}
                  </Typography>
                  <FormControlLabel 
                    control={
                      <Checkbox 
                          onChange={(_, checked) => {
                            let domainSetting: number = campaignState.campaign.domainSetting;
                            if(!checked) {
                              domainSetting = ZEUS_DOMAIN_SETTING.UNSPECIFIED;
                            }
                            if(checked){
                              domainSetting = domainSettingTmp;
                            }
                            campaignState.setCampaign({
                              ...campaignState.campaign,
                              domainSetting: domainSetting,
                            });
                        }}
                        checked={campaignState.campaign.domainSetting != ZEUS_DOMAIN_SETTING.UNSPECIFIED}
                      />
                    } 
                    label="設定する"                 
                  />
                </Grid>
              </>}
              {(campaignState.campaign.deliveryType === ZEUS_DELIVERY_TYPE.DSP && campaignState.campaign.domainSetting != ZEUS_DOMAIN_SETTING.UNSPECIFIED) &&
              <>
                <Grid item xs={12}>
                  <ButtonGroup variant="contained" aria-label={inputProps.domainSetting.ariaLabel}>
                    <Button
                      color={campaignState.campaign.domainSetting === ZEUS_DOMAIN_SETTING.DOMAIN_EXCLUSION ? "primary" : undefined}
                      onClick={() => {
                        campaignState.setCampaign({
                          ...campaignState.campaign,
                          domainSetting: ZEUS_DOMAIN_SETTING.DOMAIN_EXCLUSION,
                        });
                        setDomainSettingTmp(ZEUS_DOMAIN_SETTING.DOMAIN_EXCLUSION)
                      }}
                    >除外</Button>
                    <Button
                      color={campaignState.campaign.domainSetting === ZEUS_DOMAIN_SETTING.DOMAIN_SPECIFICATION ? "primary" : undefined}
                      onClick={() => {
                        campaignState.setCampaign({
                          ...campaignState.campaign,
                          domainSetting: ZEUS_DOMAIN_SETTING.DOMAIN_SPECIFICATION,
                        });
                        setDomainSettingTmp(ZEUS_DOMAIN_SETTING.DOMAIN_SPECIFICATION)
                      }}
                    >指定</Button>
                  </ButtonGroup>
                </Grid>
              </>}
              {(campaignState.campaign.deliveryType === ZEUS_DELIVERY_TYPE.DSP && campaignState.campaign.domainSetting === ZEUS_DOMAIN_SETTING.DOMAIN_EXCLUSION) &&
                <Grid item xs={12}>
                  <Typography variant="caption" display="block">
                    {"※複数入力する場合は改行で区切って入力してください。"}
                  </Typography>
                  <ApolloBasicTextField
                    id={inputProps.adCampaignExcludingDomains.id}
                    label={""}
                    value={campaignState.campaign.adCampaignExcludingDomains?.join("\n")}
                    variant={"outlined"}
                    multiline={inputProps.adCampaignExcludingDomains.multiline}
                    minRows={inputProps.adCampaignExcludingDomains.rows - 1}
                    maxRows={inputProps.adCampaignExcludingDomains.rows - 1}
                    inputRef={register(
                      inputProps.adCampaignExcludingDomains.rules,
                    )}
                    error={errors.adCampaignExcludingDomains}
                    setState={(e: any) => {
                      const val: string[] = String(e ?? "").split("\n")
                      campaignState.setCampaign({
                        ...campaignState.campaign,
                        adCampaignExcludingDomains: val,
                      })
                    }}
                  />
                  <Grid container xs={12} justifyContent="flex-end">
                    <Button
                      type="button"
                      color="primary"
                      className={classes.button}
                      onClick={async () => {
                        let type = 0
                        const text = campaignState.campaign.adCampaignExcludingDomains?.join("\n") ?? ""
                        await navigator.clipboard.writeText(text)
                        .then(()=>{type = 1})
                        .catch(()=>{type = -1})
                        .finally(()=>{
                          setmsg({
                            type: "setMessage",
                            payload: {
                              ...data,
                              open: true,
                              type: getResultType(type),
                              message: type === 1 ? "クリップボードにコピーしました。" : "コピーに失敗しました。",
                            }
                          });
                        });
                      }}
                      variant="contained"
                    >
                      クリップボードにコピー
                    </Button>
                  </Grid>
                </Grid>
              }
              {(campaignState.campaign.deliveryType === ZEUS_DELIVERY_TYPE.DSP && campaignState.campaign.domainSetting === ZEUS_DOMAIN_SETTING.DOMAIN_SPECIFICATION) &&
                <Grid item xs={12}>
                  <Typography variant="caption" display="block">
                    {"※複数入力する場合は改行で区切って入力してください。"}
                  </Typography>
                  <ApolloBasicTextField
                    id={inputProps.adCampaignTargetDomains.id}
                    label={""}
                    value={campaignState.campaign.adCampaignTargetDomains?.join("\n")}
                    variant={"outlined"}
                    multiline={inputProps.adCampaignTargetDomains.multiline}
                    minRows={inputProps.adCampaignTargetDomains.rows - 1}
                    maxRows={inputProps.adCampaignTargetDomains.rows - 1}
                    inputRef={register(
                      inputProps.adCampaignTargetDomains.rules,
                    )}
                    error={errors.adCampaignTargetDomains}
                    setState={(e: any) => {
                      const val: string[] = String(e ?? "").split("\n")
                      campaignState.setCampaign({
                        ...campaignState.campaign,
                        adCampaignTargetDomains: val,
                      })
                    }}
                  />
                  <Grid container xs={12} justifyContent="flex-end">
                    <Button
                      type="button"
                      color="primary"
                      className={classes.button}
                      onClick={async () => {
                        let type = 0
                        const text = campaignState.campaign.adCampaignTargetDomains?.join("\n") ?? ""
                        await navigator.clipboard.writeText(text)
                        .then(()=>{type = 1})
                        .catch(()=>{type = -1})
                        .finally(()=>{
                          setmsg({
                            type: "setMessage",
                            payload: {
                              ...data,
                              open: true,
                              type: getResultType(type),
                              message: type === 1 ? "クリップボードにコピーしました。" : "コピーに失敗しました。",
                            }
                          });
                        });
                      }}
                      variant="contained"
                    >
                      クリップボードにコピー
                    </Button>
                  </Grid>
                </Grid>
              }
              <Grid item xs={12}>
                <ApolloBasicSelect
                  id={inputProps.trackingPoints.id}
                  label={inputProps.trackingPoints.label}
                  options={inputProps.trackingPoints.options}
                  value={campaignState.campaign.trackingPoints}
                  isMulti={inputProps.trackingPoints.isMulti}
                  control={control}
                  readOnly={inputProps.trackingPoints.readOnly}
                  errors={errors.trackingPoints}
                  rules={inputProps.trackingPoints.rules}
                  menuPlacement={inputProps.trackingPoints.menuPlacement}
                  attention={
                    <Typography variant="caption" gutterBottom display="block" style={{whiteSpace: "normal"}}>
                      {"※パフォーマンス広告を実施の際は、イベント名「dadoptpoint」のイベントタグの設置が必須となります。"}
                      <br/>
                      {"　こちらのイベントタグを設置した箇所が最適化ポイントとなり、最適化ポイントCVとして計測されます。"}
                      <br/>
                      {"　最適化ポイントCVは測定ポイントを作成頂く必要はありませんが、1つ以上の測定ポイントが紐づいているキャンペーンのみ計測対象となりますのでご注意ください。"}
                    </Typography>
                  }
                  setState={(e: any) => {
                    const setVal = e ? e.map((target: Option) => {
                      return target.value;
                    }) : [];
                    campaignState.setCampaign({
                      ...campaignState.campaign,
                      trackingPoints: setVal,
                    });
                  }}
                />
                {errorMessages.trackingPoints !== "" &&
                <Typography variant="caption" className={classes.errorMessage}>
                  {errorMessages.trackingPoints}
                </Typography>
                }
              </Grid>
            </Grid>
          </CardContent>
          <CardActions className={classes.cardaction}>
            <ApolloUserProfileAuth role={APOLLO_GROUP_OPERATOR} profile={APOLLO_SYSTEM_ADMIN}>
              <Button
                type="submit"
                color="primary"
                className={classes.button}
                onClick={onSubmit}
                variant="contained"
                disabled={!isValid(campaignState.campaign, errorMessages) || processing.current}
              >
                {campaignId === 0 ?
                  "作成" :
                  "更新"
                }
              </Button>
            </ApolloUserProfileAuth>
            <Button
              variant="contained"
              color="inherit"
              onClick={goBackAction}
              className={classes.button}
              disabled={processing.current}
            >
              {isEditor ? "キャンセル" : "戻る"}
            </Button>
          </CardActions>
        </Card>
      </form>
    </React.Fragment>
  );
};

export default CampaignFormZeus;
